import {Component} from "react";
import * as React from "react";

import moment from "moment";
import {Bar} from "react-chartjs-2";
import {WorkloadStats} from "../models/WorkloadAnalytics";
import * as _ from "lodash";
import {BAR_CHART_OPTIONS} from "./AssignmentsOverTimeCard";

interface WorkloadStatusesOverTimeCardProps
{
    workloadStats: WorkloadStats[];
}

interface WorkloadStatusesOverTimeCardState
{
    completedData?: {t: Date,y: number}[]
    failedData?: {t: Date,y: number}[]
}

export default class WorkloadStatusesOverTimeCard extends Component<WorkloadStatusesOverTimeCardProps,WorkloadStatusesOverTimeCardState>
{
    constructor(props: Readonly<WorkloadStatusesOverTimeCardProps>) {
        super(props);

        this.state = {
            completedData: undefined,
            failedData: undefined
        }
    }

    public componentDidMount() {
        if(this.props.workloadStats)
        {
            this.setData();
        }
    }


    componentDidUpdate(prevProps: Readonly<WorkloadStatusesOverTimeCardProps>, prevState: Readonly<WorkloadStatusesOverTimeCardState>, snapshot?: any): void {
        if(this.props.workloadStats !== prevProps.workloadStats)
        {
            this.setData();
        }
    }

    private setData()
    {
        if(this.props.workloadStats)
        {
            const completedData: any[] = [];
            const failedData: any[] = [];
            
            const groupedWorkloadStats: any = _.groupBy(this.props.workloadStats,(wls: WorkloadStats) => wls.date);
            _.keys(groupedWorkloadStats).forEach((date: string) => {
                
                const t = moment(date).toDate();
                
                completedData.push({
                    t,
                    y: _.sumBy(groupedWorkloadStats[date],(wls: WorkloadStats) => wls.completedCount),
                });
                
                failedData.push({
                    t,
                    y: _.sumBy(groupedWorkloadStats[date],(wls: WorkloadStats) => wls.failedCount),
                });
            });

            
            this.setState({
                completedData,
                failedData
            });
        }
    }

    public render() {

        if(this.state.completedData == undefined)
        {
            return null;
        }
        
        const barChartData =
            {
                datasets: [{
                    label: "Completed",
                    backgroundColor: "#99c140",
                    data: this.state.completedData,
                },
                {
                    label: "Failed",
                    backgroundColor: "#cc3232",
                    data: this.state.failedData,
                }],
            };


        return (
            <div className={"card card--padded flex-item--flex-1"}>
                <Bar data={barChartData} width={8} height={1} options={BAR_CHART_OPTIONS}/>
                <span className={"p-top-1rem"}>Workloads</span>
                <span className={"text-extra-detail"}>Status by date created.</span>
            </div>
        );

    }
}